var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubcategoryicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 232.876 221.866",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78947 50.7501C8.78947 26.9029 28.1214 7.57093 51.9686 7.57093C75.8158 7.57093 95.1478 26.9029 95.1478 50.7501C95.1478 74.5973 75.8158 93.9292 51.9686 93.9292C28.1214 93.9292 8.78947 74.5973 8.78947 50.7501ZM50.5416 97.0258C50.5416 119.453 51.0023 132.65 54.4982 144.752C62.7724 173.394 85.5314 177.453 132.995 177.453M135.866 173.627C135.866 149.78 155.198 130.448 179.045 130.448C202.893 130.448 222.224 149.78 222.224 173.627C222.224 197.474 202.893 216.806 179.045 216.806C155.198 216.806 135.866 197.474 135.866 173.627Z",
    fill: "none",
    opacity: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 20
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcategoryicon);
export default __webpack_public_path__ + "static/media/subcategoryicon.9c98672ba93fb1dd07d60dad5984feb8.svg";
export { ForwardRef as ReactComponent };